(function() {
    'use strict';

    angular
        .module('atheer.cloud', [

        ]);
})();
